import * as types from '../actions/types';
import ReactOnRails from "react-on-rails";

const initState = {
    authenticating: true,
    isAuthenticated: false,
    id: null,
    name: null,
    csrfToken: null,

    userRegistration: false,
    passwordResetting: false,
    passwordResetRequesting: false
};

export default function AuthReducer (state = initState, action) {

    switch (action.type)
    {
        // Auth Init

        case types.AUTH_INIT:
            return {...state, authenticating: true };

        case types.AUTH_INIT_SUCCESS:
            let name = (action.payload.success && action.payload.user) ? action.payload.user : null;
            return {...state, authenticating: false, isAuthenticated: action.payload.success, name: name, id: action.payload.id, type: action.payload.type };

        case types.AUTH_INIT_ERROR:
            return {...state, authenticating: false, isAuthenticated: false, name: name };

        // Sign In

        case types.AUTH_SIGN_IN:
            return {...state, authenticating: true, isAuthenticated: false, name: null };

        case types.AUTH_SIGN_IN_SUCCESS:
            let signed_user_name = action.payload.email || action.payload.username;
            return {...state, authenticating: false, isAuthenticated: true, name: signed_user_name, id: action.payload.id, type: action.meta.type };

        case types.AUTH_SIGN_IN_ERROR:
            return {...state, authenticating: false, isAuthenticated: false };

        // Sign Out

        case types.AUTH_SIGN_OUT:
            return {...state, isAuthenticated: false, name: null };

        case types.AUTH_SIGN_OUT_SUCCESS:
            return state;

        case types.AUTH_SIGN_OUT_ERROR:
            return state;

        // Registration

        case types.AUTH_REGISTER:
            return {...state, userRegistration: true};

        case types.AUTH_REGISTER_SUCCESS:
            return {...state, userRegistration: false};

        case types.AUTH_REGISTER_ERROR:
            return {...state, userRegistration: false};

        // Password reset

        case types.AUTH_PASSWORD_RESET:
            return {...state, passwordResetting: true };

        case types.AUTH_PASSWORD_RESET_SUCCESS:
            return {...state, passwordResetting: false };

        case types.AUTH_PASSWORD_RESET_ERROR:
            return {...state, passwordResetting: false };

        // Password reset request

        case types.AUTH_PASSWORD_RESET_REQUEST:
            return {...state, passwordResetRequesting: true };

        case types.AUTH_PASSWORD_RESET_REQUEST_SUCCESS:
            return {...state, passwordResetRequesting: false };

        case types.AUTH_PASSWORD_RESET_REQUEST_ERROR:
            return {...state, passwordResetRequesting: false };

        // Password reset

        case types.AUTH_EXPIRED:
            return {...state, authenticating:false, isAuthenticated: false, name: null };

        default:
            return state;
    }

}
